import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AbstractResource } from '../../core/http/abstract-resource';
import { stopWorkProjectStepPath } from '../../cross-team-shared/hub-paths';
import { RedirectResponse } from '../../team-apis/otterdam/redirect-response';

@Injectable({ providedIn: 'root' })
export class StepResource extends AbstractResource {
  stopWork$(projectId: number, stepId: number, token: string) {
    return this.request$<RedirectResponse>(
      'POST',
      `${environment.sh3BaseUrl}${stopWorkProjectStepPath(projectId, stepId)}`,
      {
        body: '',
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
}
